import React from 'react';

const About = () => (
  <>
    <div>Public Page</div>
  </>
);

export default About;
